export default __webpack_public_path__ + "static/media/logo.d2fb95f6.png";